/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * ChangHeon Yoo (chyoo@rsupport.com)
 *
 * @description
 *
 * @created at Wed Apr 17 2024
 **/

import { Properties } from "@/frameworks/libraries";

export default function useCallSound() {
	const playCallStartSound = () => {
		Properties.emit("sound_command", {
			name: "phonecall_sound",
			type: "play",
			src: `/audio/call.mp3?t=${Date.now()}`,
			playTime: 60
		});
	};
	const stopCallSound = () => {
		Properties.emit("sound_command", {
			name: "phonecall_sound",
			type: "stop",
			src: `/audio/call.mp3?t=${Date.now()}`
		});
	};
	const playCallEndSound = () => {
		Properties.emit("sound_command", {
			name: "phonecall_end_sound",
			type: "play",
			src: `/audio/call_close.mp3?t=${Date.now()}`
		});
	};
	return { playCallStartSound, stopCallSound, playCallEndSound };
}
